import request from '@/config/axios'

export const getDepositPage = (params: any) => request.get({ url: '/rental/deposit/page', params })
export const auditDeposit = (data: { id: number; pass: boolean; remark?: string }) =>
  request.put({ url: '/rental/deposit/audit', data })
